import statisticalAreaPlugin from './statisticalAreaPlugin';
import utilPlugin from './utilPlugin';

const plugins = {
  statisticalAreaPlugin,
  utilPlugin,
};

export default plugins;
